export const PAYMENT_LINK_NEW_BADGE_PHASE_2 = 'Payments:NewBadgeSPLPhase2';